import { render, staticRenderFns } from "./delivery-greenhouse.vue?vue&type=template&id=4b81c014"
import script from "./delivery-greenhouse.vue?vue&type=script&lang=js"
export * from "./delivery-greenhouse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports